import { render, staticRenderFns } from "./MasterSingleSalary.vue?vue&type=template&id=3559e577"
import script from "./MasterSingleSalary.vue?vue&type=script&lang=js"
export * from "./MasterSingleSalary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports